import {
  AHB_MESSAGE_TYPE,
  AHB_PROCEDURE_ID,
  AHB_SUBPROCEDURE,
  AHB_WITHDRAW_REASON,
  SCHEMA_VERSION,
} from "core/consts";
import type { SchemaVersion } from "core/types";
import { z } from "zod";
import {
  ahbDateinummerSchema,
  AHBdateSchema,
  AHBdateSchemaV2,
  AHBtimeSchema,
  IKNumberSchema,
} from "./shared";

export const AHBWithdrawalSchema = z.object({
  Nutzdaten: z.object({
    "@xmlns": z.string(),
    "@xmlns:aar": z.string(),
    "@xmlns:arh": z.string(),
    "@xmlns:feh": z.string(),
    "@xmlns:gdb": z.string(),
    "@xmlns:sto": z.string(),

    Body: z.object({
      Stornonachricht: z.object({
        "sto:Begruendung": z
          .object({
            "sto:Erlaeuterung": z.string().max(600).optional().nullable(),
            "sto:Grund": z.enum(AHB_WITHDRAW_REASON),
          })
          .superRefine((data, ctx) => {
            if (data["sto:Grund"] === AHB_WITHDRAW_REASON.OTHER) {
              if (
                !data["sto:Erlaeuterung"] ||
                data["sto:Erlaeuterung"].trim() === ""
              ) {
                ctx.addIssue({
                  code: z.ZodIssueCode.custom,
                  message:
                    'Erläuterung is required when Grund is "9 - Sonstiges".',
                  path: ["sto:Erlaeuterung"],
                });
              }
            }
          }),
        "sto:Datei_ID": z.uuid(),
      }),
    }),

    Header: z.object({
      "gdb:Absender": z.object({
        "gdb:Krankenhaus": z.object({
          "gdb:Institutionskennzeichen": IKNumberSchema,
        }),
      }),
      "gdb:Datei_ID": z.uuid(),
      "gdb:Empfaenger": z.object({
        "gdb:Krankenkasse": z.object({
          "gdb:Institutionskennzeichen": IKNumberSchema,
        }),
      }),
      "gdb:Erstellungsdatum": AHBdateSchema,
      "gdb:Erstellungszeit": AHBtimeSchema,
      "gdb:Logische_Version": z.enum(SCHEMA_VERSION),
      "gdb:Nachrichtentyp": z.literal(AHB_MESSAGE_TYPE.WITHDRAWAL),
      "gdb:Unterverfahren": z.literal(AHB_SUBPROCEDURE),
      "gdb:Verfahrenskennung": z.enum(AHB_PROCEDURE_ID),
      "gdb:Dateinummer": ahbDateinummerSchema,
    }),
  }),
});

// v2.0: Erstellungsdatum uses YYYY-MM-DD format
const AHBWithdrawalSchemaV2 = AHBWithdrawalSchema.extend({
  Nutzdaten: AHBWithdrawalSchema.shape.Nutzdaten.extend({
    Header: AHBWithdrawalSchema.shape.Nutzdaten.shape.Header.extend({
      "gdb:Erstellungsdatum": AHBdateSchemaV2,
    }),
  }),
});

export function getAHBWithdrawalSchema(schemaVersion: SchemaVersion) {
  return schemaVersion === SCHEMA_VERSION.V2_0_0
    ? AHBWithdrawalSchemaV2
    : AHBWithdrawalSchema;
}
